interface Props {
    children: React.ReactNode;
    htmlFor?: string;
    className?: string;
}

export default function Label({children, htmlFor, className = ''}: Props) {
    return (<label htmlFor={htmlFor}
                   className={`text-[1rem] leading-tight font-medium leading-2 flex items-center gap-2 my-2 px-2 ${className} [&>p>a]:underline`}>{children}</label>);
}
